// Components
import Picto from '../../../atoms/Picto/Picto';

// Styles
import styles from './SimpleIconCell.module.css';

/**
 * Simple icon cell component for SimpleTable
 * @param {object} props
 * @param {string} props.icon - Icon name
 * @param {string} [props.color] - Icon color
 * @param {string} [props.url] - Optional link URL
 * @param {string} [props.className] - Additional CSS classes
 * @returns {JSX.Element}
 */
function SimpleIconCell({
  icon,
  color,
  url,
  className = '',
}) {
  const iconContent = (
    <Picto
      icon={/** @type {any} */ (icon)}
      props={color ? { color } : undefined}
      className={className}
    />
  );

  if (url) {
    return (
      <a href={url} className={styles['simple-icon-cell-link']}>
        {iconContent}
      </a>
    );
  }

  return iconContent;
}

export default SimpleIconCell;
